export default __webpack_public_path__ + "static/media/home-digital-agency-img-01.a4a033fb.png";